import { render, staticRenderFns } from "./mealplan.vue?vue&type=template&id=5dbc5f29&scoped=true"
import script from "./mealplan.vue?vue&type=script&lang=js"
export * from "./mealplan.vue?vue&type=script&lang=js"
import style0 from "./mealplan.vue?vue&type=style&index=0&id=5dbc5f29&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc5f29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbc5f29')) {
      api.createRecord('5dbc5f29', component.options)
    } else {
      api.reload('5dbc5f29', component.options)
    }
    module.hot.accept("./mealplan.vue?vue&type=template&id=5dbc5f29&scoped=true", function () {
      api.rerender('5dbc5f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/mealplan.vue"
export default component.exports